import { render, staticRenderFns } from "./AddMetadataDialog.vue?vue&type=template&id=48eef1a8"
import script from "./AddMetadataDialog.vue?vue&type=script&lang=js"
export * from "./AddMetadataDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports